module.exports = __webpack_public_path__ + "img/Girl_030005.26c39f51.png";